import { componentsByType } from '../constants';
import { FormFactoryElement } from '../types/element.types';

export function getComponentByType(type: FormFactoryElement['type']) {
	return componentsByType[type];
}
